// REACT REDUX SETUP
import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';

// COMPONENTS
import CompanyPortalWizardDialog from 'containers/CompanyContainer/CompanyPortalWizardDialog';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import ProviderProfileButton from './ProviderProfileButton';
import styled from 'styled-components';
import { Calendar } from '../../components/Calendar/Calendar';
import { FluidSection } from '../../components/FluidSection/FluidSection';
import CircularProgress from 'material-ui/CircularProgress';
import ClientTable from './ClientTable';
import FormTextArea from './Forms/Components/FormTextArea';
import ProviderHeader from './ProviderHeader';
import CalendarDialogSubtitle from './CalendarDialogSubtitle';
import ConfirmationDialogBody from './ConfirmationDialogBody';

// UTILITIES
import toArray from 'lodash/toArray';
const moment = require('moment-timezone');
import getProviderList from './utils/getProviderList';
import getProviderServicesList from './utils/getProviderServicesList';
import { getUserTimezone } from '../../utils/timezoneUtils';
import { sendOnScreenCompanyNotification } from '../../utils/notificationUtils';

class GetBookWithClientWizardStep extends React.Component {
    state = {
        selectedProvider: null,
        selectedService: null,
        reasonText: undefined, // USING UNDEFINED DUE TO REACT WARNING ON null FOR CONTROLLED textarea
        tempBookingData: null,
        loading: false,
        errorMessage: null,
    };

    componentDidUpdate(prevProps){
        if (this.props.calendar !== prevProps.calendar) {
            this.setState({
                loading: false,
            });
        };
    };

    handleWizardStepChange = (offset) => {
        const { currentWizardStep } = this.props;
        const newPage = currentWizardStep + offset;
        this.props.changeWizardStep({newPage});
        // window.scrollTo(0, 0);
        document.getElementById('top').scrollIntoView();
    };

    getSelectedService = (service) => {
        this.handleWizardStepChange(1);
        let { SBMId } = this.state.selectedProvider;
        this.props.getCalendar(SBMId, service.SBMId);
        this.setState({
            loading: true,
            selectedService: service,
        });
    };

    setBookingData = ({thisWeekStartDate, serviceId, providerId, time, date, index, selectedProviderData}) => {
        let bookingData = {
            serviceId,
            providerId,
            startDate: date,
            startTime: time,
        };
        this.handleWizardStepChange(1);
        this.setState({
            tempBookingData: bookingData,
        });
    };

    validateBookingReason = () => {
        let { reasonText } = this.state;
        if (!reasonText) {
            this.setState({errorMessage: "A reason for booking is required."})
        }
        else {
            this.handleWizardStepChange(1);
            this.setState({errorMessage: null})
        };
    };

    saveClientInfo = (selectedClient, nextWizardStep) => {
        this.props.saveCurrentBookingClientData({selectedClient});
        this.handleWizardStepChange(nextWizardStep);
    };

    saveBookingData = ({selectedProvider, selectedService, reasonText, tempBookingData, nextWizardStep}) => {
        let bookingData;
        if (selectedProvider && selectedService && reasonText && tempBookingData) {
            let firstName = selectedProvider.name.first;
            let lastName = selectedProvider.name.last;
            const {
                serviceId,
                providerId,
                startDate,
                startTime,
            } = tempBookingData;
            const additionalData = {
                '61b06abc1fed07fc9a14e6c83e61a821': moment(startDate, 'YYYY-MM-DD').format('MMMM Do, YYYY'), // Appointment Date
                '9f10afef7f506749032d6c22f048d762': serviceId,
                'ded3bb26bf6ec831b4408ca1962f3e93': moment(startTime, 'HH:mm:ss').format('h:mm a'), // Appointment Time
                '77f6b6926ba83ab72889940dbf7e6ae7': moment.tz.guess(),
            };
            bookingData = {
                serviceId,
                serviceKey: selectedService._id,
                providerId,
                providerKey: selectedProvider.uid,
                startDate,
                startTime,
                additionalData,
                reason: reasonText.trim(),
                firstName,
                lastName
            };
        }
        else {
            bookingData = null;
        };
        this.props.saveCurrentSelectedServiceData({selectedService});
        this.props.saveTempBookingData({bookingData});
        this.handleWizardStepChange(nextWizardStep);
    };

    confirmBooking = ({savedTempBookingData, currentBookingClient, currentSelectedService, companyId}) => {
        let { startDate, startTime, providerKey, serviceKey, providerId, serviceId, additionalData, reason, firstName, lastName } = savedTempBookingData;
        let clientId = currentBookingClient.uid;
        let servicePeriod = {
            startDate,
            startTime,
            duration: currentSelectedService.duration,
            userTimezone: getUserTimezone(),
        };
        this.props.getActivePeriodKey({
            servicePeriod,
            clientId,
            serviceId: serviceKey,
            providerId: providerKey,
            firstName,
            lastName
        }).then(activePeriodKey => {
            this.props.bookConsult({
                userId: clientId,
                serviceId: serviceId,
                providerId: providerId,
                startDate,
                startTime,
                additionalData,
                reason,
                providerKey,
                serviceKey,
                activePeriodKey,
                clientId: currentBookingClient.SBMClientId,
                bookingFromCompanyDashboard: true
            })
            .then(({confirmationRef, bookingData, confirmationData}) => {
                console.log(confirmationData)
                if (confirmationData) {
                    sendOnScreenCompanyNotification({
                        companyId,
                        type: 'success',
                        title: 'Success',
                        message: "Booking successfully completed."
                    })
                }
                else if (!confirmationData) {
                    sendOnScreenCompanyNotification({
                        companyId,
                        type: 'failed',
                        title: 'Failed',
                        message: "There was a problem completing the booking.  Please try again."
                    });
                }
                confirmationRef.off();
                this.props.handleDialogStatusChange({
                    open: false,
                    type: null,
                    step: null
                });
            })
        })
    };

    GetBookWithClientWizardStepContent = (pageNumber) => {
        // CREATE VARIABLES FOR EACH STEP
        let key = pageNumber;
        let titleProps;
        let body;
        let actions;
        let nextWizardStep;
        let {
            providers,
            services,
            companyInfo,
            companyId,
            savedTempBookingData,
            currentBookingClient,
            currentSelectedService
        } = this.props;
        let {
            selectedProvider,
            selectedService,
            reasonText,
            tempBookingData,
            loading
        } = this.state;
        let clientName = currentBookingClient ?
            `${currentBookingClient.basicProfile.firstName} ${currentBookingClient.basicProfile.lastName}` :
            null;
        let startDate = tempBookingData ? tempBookingData.startDate : null;
        let startTime = tempBookingData ? tempBookingData.startTime : null;
        let formattedDate = startDate ? moment(startDate).format("dddd, MMMM Do YYYY") : null;
        let providerName = selectedProvider ? selectedProvider.name.first + " " + selectedProvider.name.last : null;

        switch(pageNumber){
            case 0:
                titleProps = {
                    title: "Choose Provider",
                    subtitle: ``,
                    subtitleColor: 'blue',
                    hasBorder: true,
                };

                let providerList = getProviderList(providers);
                body =  (
                    <FluidSection
                        sectionMaxWidth="fit-content"
                        sectionMinWidth="fit-content"
                        style={{width:"auto"}}
                        children={providerList.map((provider, index) => {
                            providerName = provider.name.first + ' ' + provider.name.last;
                            return  (
                                    <ProviderProfileButton
                                        key={index}
                                        background="light"
                                        profilePhotoURL={provider.profilePhotoURL}
                                        text={providerName}
                                        onClick={() => {
                                            this.handleWizardStepChange(1);
                                            this.setState({selectedProvider: provider});
                                        }}
                                    />
                            )
                        })}
                    />
                )

                actions = [ <CompanyPageButton
                                children={'Back'}
                                key={key}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => {
                                    this.props.handleDialogStatusChange({
                                        open: false,
                                        type: null,
                                        step: null,
                                    });
                                    this.setState({selectedProvider: null});
                                }}
                            />
                ];
                break;
            case 1:
                titleProps = {
                    title: "Choose Service",
                    subtitle: <ProviderHeader
                                text={providerName}
                                profilePhotoURL={selectedProvider.providerProfilePhoto}
                            />,
                    subtitleColor: 'blue',
                    hasBorder: true,
                };

                let providerServices = getProviderServicesList(services, selectedProvider.uid);
                body = providerServices.map((service, index) => {
                    return (
                        service.SBMId && (
                            <CompanyPageButton
                                key={index}
                                children={service.name}
                                borderStyle="1px solid black"
                                buttonStyle={{color:"black", background: "lightgrey"}}
                                onClick={() => this.getSelectedService(service)}
                            />
                        )
                    )
                });

                actions = [ <CompanyPageButton
                                children={'Back'}
                                key={key}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => {
                                    this.handleWizardStepChange(-1);
                                    this.setState({selectedServiceSBMId: null, selectedServiceId: null});
                                }}
                            />
                ];
                break;
            case 2:
                titleProps = {
                    title: "Choose Time Slot",
                    subtitle: <CalendarDialogSubtitle
                                serviceName={selectedService.name}
                                providerName={providerName}
                            />,
                    subtitleColor: '',
                    hasBorder: true,
                    subtitlePosition:{width:"100%"}
                };

                body = loading
                            ? <CircularProgress size={50}/>
                            : <Calendar setBookingData={this.setBookingData} />;

                actions = [ <CompanyPageButton
                                key={key}
                                children={'Back'}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => this.handleWizardStepChange(-1)}
                            />
                ];
                break;
            case 3:
                titleProps = {
                    title: "Booking Notes",
                    subtitle: `Please enter any booking details for your records.`,
                    subtitleColor: 'blue',
                    hasBorder: false,
                };

                body =  <FormTextArea
                            onChange={(e) => this.setState({reasonText: e.target.value.trimStart()})}
                            value={this.state.reasonText}
                            label="Add any significant booking details here such as a reason for consult."
                            name="reason"
                            required="required"
                            errorMessage={this.state.errorMessage}
                        />;

                actions = [ <CompanyPageButton
                                key={key}
                                children={'Back'}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => {
                                    this.handleWizardStepChange(-1);
                                    this.setState({reasonText: undefined}); // USING UNDEFINED DUE TO REACT WARNING ON null FOR CONTROLLED textarea
                                }}
                            />,
                            <CompanyPageButton
                                key={key + 1}
                                children={'Next'}
                                type={"dark"}
                                onClick={this.validateBookingReason}
                            />
                ];
                break;
            case 4:
                titleProps = {
                    title: "Confirm Your Booking Information",
                    subtitle: `This will be finalized in a later step`,
                    subtitleColor: 'blue',
                    hasBorder: false,
                };

                body =  <ConfirmationDialogBody
                            serviceName={selectedService.name}
                            providerName={providerName}
                            bookingDate={formattedDate}
                            bookingTime={startTime}
                        />

                actions = [ <CompanyPageButton
                                key={key}
                                children={'Back'}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => this.saveBookingData({nextWizardStep: -1})}
                            />,
                            <CompanyPageButton
                                key={key + 1}
                                children={'Next'}
                                type={"dark"}
                                onClick={() =>
                                    this.saveBookingData({
                                        selectedProvider,
                                        selectedService,
                                        reasonText,
                                        tempBookingData,
                                        nextWizardStep: 1
                                    })}
                            />
                ];
                break;
            case 5:
                titleProps = {
                    title: "Choose Client",
                    subtitle:   <CompanyPageButton
                                    children={'Add New Client'}
                                    type={"light"}
                                    onClick={() =>
                                        this.props.handleDialogStatusChange({
                                            open: true,
                                            type: 'addClient',
                                            step: 0
                                        })}
                                />,
                    subtitleColor: 'blue',
                    hasBorder: true,
                    subtitlePosition:{alignSelf:"flex-end"}
                };

                body =  <ClientTable
                            clients={companyInfo.directBillingHSCs}
                            onClick={this.saveClientInfo}
                            buttonText="Book"
                        />;

                actions = [ <CompanyPageButton
                                key={key}
                                children={'Back'}
                                buttonStyle={{color:"white", background: "grey"}}
                                onClick={() => {
                                    // USING null TO NULLIFY currentBookingClient IN STORE
                                    this.saveClientInfo(null, nextWizardStep = -1);
                                }}
                            />
                ];
                break;
            case 6:
                titleProps = {
                    title: `Book a Consultation with ${clientName}`,
                    subtitle: loading
                                ? `We're processing your booking.`
                                :``,
                    subtitleColor: 'blue',
                    hasBorder: true,
                };

                let nameOfProvider = savedTempBookingData.firstName + " " + savedTempBookingData.lastName;
                body =  loading
                            ? <CircularProgress size={50}/>
                            : <ConfirmationDialogBody
                                serviceName={currentSelectedService.name}
                                providerName={nameOfProvider}
                                bookingDate={moment(savedTempBookingData.startDate).format("dddd, MMMM Do YYYY")}
                                bookingTime={savedTempBookingData.startTime}
                            />

                actions = loading
                            ? [null]
                            : [ <CompanyPageButton
                                key={key}
                                children={'Back'}
                                buttonStyle={{color:"white", background: "grey"}}
                                disabled={loading}
                                onClick={() => this.handleWizardStepChange(-1)}
                            />,
                            <CompanyPageButton
                                key={key + 1}
                                children={'Confirm'}
                                type={"dark"}
                                disabled={loading}
                                onClick={() => {
                                    this.confirmBooking({
                                        savedTempBookingData,
                                        currentBookingClient,
                                        currentSelectedService,
                                        companyId
                                    })
                                    this.setState({loading: true});
                                }}
                            />
                ];
                break;
        }
        return(<CompanyPortalWizardDialog headerProps={titleProps} body={body} actions={actions} key={key} />);
    }
    render() {
        let { pageNumber } = this.props;
        let child = this.GetBookWithClientWizardStepContent(pageNumber);
        return (
            <React.Fragment>
                {child}
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({company, calendar, booking, client}) => ({
    providers: company.providers,
    companyInfo: company.companyInfo,
    services: company.services,
    currentWizardStep: company.currentWizardStep,
    calendar: calendar,
    savedTempBookingData: booking.tempBookingData,
    currentBookingClient: booking.currentBookingClient,
    currentSelectedService: booking.currentSelectedService,
    companyId: client.clientData.providerCompany
});


export default connect(mapStateToProps,actions)(GetBookWithClientWizardStep);


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/GetBookWithClientWizardStep.jsx